'use client';

import React from 'react';
import { styled } from '@linaria/react';

import useIsOnscreen from '@/hooks/use-is-onscreen';

import Demo, {
  DemoRadioControl,
  DemoSliderControl,
} from '@/components/Demo';
import PrideFlag from './PrideFlag';

function PrideFlagDemoUnit({ controlsVariant = 'original' }) {
  const id = React.useId();

  const ref = React.useRef();
  const isOnscreen = useIsOnscreen(ref);

  const controls = React.useMemo(() => {
    return controlsVariant === 'original'
      ? [
          <DemoRadioControl
            key="variant"
            id="variant"
            label="Variant"
            options={[
              { label: 'Rainbow 🏳️‍🌈', value: 'rainbow' },
              { label: 'Trans 🏳️‍⚧️', value: 'trans' },
            ]}
          />,
          <DemoSliderControl
            key="numOfColumns"
            id="numOfColumns"
            label="Number of segments"
            min={3}
            max={20}
          />,
          <DemoSliderControl
            key="staggeredDelay"
            id="staggeredDelay"
            label="Staggered Delay"
            min={0}
            max={150}
            previewRenderer={(val) => val + 'ms'}
          />,
        ]
      : [
          <DemoRadioControl
            key="variant"
            id="variant"
            label="Variant"
            options={[
              { label: 'Rainbow 🏳️‍🌈', value: 'rainbow' },
              { label: 'Trans 🏳️‍⚧️', value: 'trans' },
            ]}
          />,
          <DemoSliderControl
            key="billow"
            id="billow"
            label="Billow"
            min={0}
            max={4}
            step={0.05}
            wrapperStyle={{
              color: 'hsl(50deg 100% 65%)',
              fontWeight: 'var(--font-weight-medium)',
            }}
            previewRenderer={(val) => val + 'px'}
          />,
        ];
  }, [controlsVariant]);

  return (
    <Demo
      id={id}
      ref={ref}
      initialValues={{
        variant: 'rainbow',
        staggeredDelay: 50,
        numOfColumns: 10,
        billow: controlsVariant === 'original' ? 8 : 1.5,
      }}
      customGrid={{
        gridTemplateColumns:
          controlsVariant === 'original'
            ? '15.3125rem 1fr 1fr'
            : '15.3125rem 1fr',
      }}
      outputWrapper={OutputWrapper}
      controls={controls}
    >
      {({ variant, numOfColumns, billow, staggeredDelay }) => {
        return (
          <Wrapper>
            {isOnscreen && (
              <PrideFlag
                key={`${numOfColumns}|${billow}`}
                variant={variant}
                numOfColumns={numOfColumns}
                staggeredDelay={staggeredDelay}
                billow={billow}
                shouldStaggerBillow={controlsVariant === 'billow'}
              />
            )}
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const OutputWrapper = styled.div`
  padding: 32px 16px;
  display: flex;
  justify-content: center;
`;

const Wrapper = styled.div`
  width: 200px;
  aspect-ratio: 3 / 2;
`;

export default PrideFlagDemoUnit;
